import React from 'react';

const Home = () => {
  return (
    <div>
      <h1>Naviauth</h1>
      <p>Welcome Naviauth</p>
      <p>Naviauth is Navien OAuth 2.0</p>
    </div>
  );
};

export default Home;